import React from "react";
import { Link } from "react-router-dom";

export const ENTITY = {
  name: "TED OPS AI LIMITED",
  number: "17486570",
  address: "Unit 5 Unit 4d Trident Business Centre, Amy Johnson Way, Blackpool, United Kingdom, FY4 2RP",
  email: "dev@tedopsai.com",
};

export const LegalLayout = ({ title, updated, children, testid }) => (
  <div className="min-h-screen bg-[#f6f5f1] text-slate-800" data-testid={testid}>
    <header className="border-b border-slate-200 bg-white">
      <div className="max-w-3xl mx-auto px-5 py-4 flex flex-wrap items-center gap-4 text-sm">
        <span className="font-black tracking-tight text-slate-900">TedOps AI</span>
        <nav className="ml-auto flex gap-4">
          <Link to="/privacy" className="hover:underline" data-testid="legal-nav-privacy">Privacy policy</Link>
          <Link to="/data-deletion" className="hover:underline" data-testid="legal-nav-deletion">Data deletion</Link>
        </nav>
      </div>
    </header>
    <main className="max-w-3xl mx-auto px-5 py-10 space-y-6 leading-relaxed text-sm sm:text-base">
      <div><h1 className="text-3xl sm:text-4xl font-black tracking-tight text-slate-900">{title}</h1>
        {updated && <p className="text-xs text-slate-500 mt-2">Last updated {updated}</p>}</div>
      {children}
    </main>
    <footer className="border-t border-slate-200 py-6 text-center text-xs text-slate-500" data-testid="legal-footer">
      {ENTITY.name} · Company number {ENTITY.number} · Registered in England and Wales · {ENTITY.address}
    </footer>
  </div>
);

export const H2 = ({ children }) => <h2 className="text-base md:text-lg font-bold text-slate-900 pt-2">{children}</h2>;
